import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDigitaloceanComponent } from './simple-icons-digitalocean.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDigitaloceanComponent ],
    exports:      [ SimpleIconsDigitaloceanComponent ],
    bootstrap:    []
})
export class SimpleIconsDigitaloceanModule {}
